import { IconBank } from '@iwoca/icons';
import { Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { useGetBankDetails } from './useGetBankDetails';
import {
    RequirementItem,
    TFundingRequirementStatus
} from '../RequirementsList/RequirementItem/RequirementItem';

type TBankDetailsStepProps = {
    status: TFundingRequirementStatus;
};

export const BankDetailsStep = ({ status }: TBankDetailsStepProps) => {
    const { bankDetails } = useGetBankDetails();

    return (
        <RequirementItem
            title={
                <FormattedMessage
                    id="_.funding_requirements.bank_details_step.title"
                    defaultMessage="Add bank details to receive funds"
                />
            }
            estimatedTime={
                <FormattedMessage
                    id="_.funding_requirements.bank_details_step.estimated_time"
                    defaultMessage="~ 1 min"
                />
            }
            href="/funding-requirements/bank-details"
            status={status}
            completedView={
                <div>
                    <Text className="font-med text-primary-10">
                        <FormattedMessage
                            id="_.funding_requirements.bank_details_step.title"
                            defaultMessage="Add bank details to receive funds"
                        />
                    </Text>
                    <div className="my-s flex items-center gap-m text-s text-structure-40">
                        <IconBank className="text-m" />
                        <span>{bankDetails?.accountNumber}</span>
                        <span>{bankDetails?.sortCode}</span>
                    </div>
                </div>
            }
        />
    );
};
